import EventRate from './EventRate'
export default EventRate